module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "widget-dashboard-icons"
  }, [_c('dash-header', {
    staticClass: "mb-5",
    attrs: {
      "date-range": _vm.$route.params.dateRange,
      "enable-date-selector": false
    },
    on: {
      "date-range-changed": _vm.triggerUpdates,
      "range-config-updated": _vm.triggerUpdates
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-start": "",
      "justify-center": "",
      "row": ""
    }
  }, [_c('v-card', {
    staticClass: "widget-report__widget mr-5"
  }, [_c('v-card-text', [_c('a', {
    attrs: {
      "href": "/#/dashboard/conversion-py"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/landing-conversions-with.png")
    }
  })])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "widget-report__widget mr-5"
  }, [_c('v-card-text', [_c('a', {
    attrs: {
      "href": "/#/dashboard/conversion"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/landing-conversions-without.png")
    }
  })])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "widget-report__widget"
  }, [_c('v-card-text', [_c('a', {
    attrs: {
      "href": "/#/dashboard/escalation"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/landing-escalations.png")
    }
  })])])], 1)], 1)], 1)
},staticRenderFns: []}